import React from 'react'
import ContentLoader from 'react-content-loader'

const CheckboxList = props => (
  <ContentLoader
    speed={2}
    width={90}
    height={25}
    viewBox="-5 0 90 25"
    backgroundColor="#cccccc"
    foregroundColor="#232323"
    {...props}
  >
    <rect x="30" y="0" rx="5" ry="5" width="52" height="20" />
    <rect x="3" y="0" rx="4" ry="4" width="20" height="20" />
  </ContentLoader>
)

export default CheckboxList